import Model from "../model";
import LoginFrom, {
  CodeForm,
  MobileLoginForm,
  EmailLoginForm
} from "../../form/login/LoginFrom";
import request from "@/lib/request/request";
import accountrequest from "@/lib/request/accountrequest";
import Auth from "@/lib/common/auth";
import Store from "@/lib/common/Store";
import Config from "@/config/config";

export class Account extends Model {
  id = "";
  email = "";
  mobile = "";
  accountType = "";
  name = "";
  position = "";
  departments = "";
  roles = "";
  startTime = 0;
  endTime = 0;
  isLongTime = 0;
  status = false;

  public showStatus() {
    if (this.status) {
      return "正常";
    } else {
      return "停用";
    }
  }
}

export class Company extends Model {
  id = "";
  name = "";
  shortName = "";
  licenceUrl = "";
  logoUrl = "";
  balance = 0;
}

export default class Info extends Model {
  token = "";
  userId = "";
  user = new Account();
  company = new Company();
  codeForm: CodeForm = new CodeForm();
  static getCode(codeForm: CodeForm) {
    // 等保需要对登录登接口进行加密
    return request.post(
      Config.aiInterviewUrl + "/account/interview/sendCaptcha",
      { ...codeForm, needAesEncrypt: true }
    );
  }

  static loginByMobileCaptcha(from: LoginFrom) {
    // 等保需要对登录登接口进行加密
    return request
      .post(Config.aiInterviewUrl + "/account/interview/login", {
        ...from,
        needAesEncrypt: true
      })
      .then(resp => {
        const info = new Info().assign(resp.data.data);
        Auth.token = info.token;
        Auth.userId = info.userId;
        Store.getAccountStoreModule().then(module => {
          module.updateAccountInfo(info);
        });
        return info;
      });
  }

  static async mobileLogin(mobileLoginForm: MobileLoginForm) {
    // 等保需要对登录登接口进行加密
    return await accountrequest
      .post(Config.aiInterviewUrl + "/account/login/mobilePassword", {
        ...mobileLoginForm,
        needAesEncrypt: true
      })
      .then(async (resp: any) => {
        const info = new Info().assign(resp.data.data);
        Auth.token = info.token;
        Auth.userId = info.userId;
        await Store.getAccountStoreModule().then(module => {
          module.updateAccountInfo(info);
        });
        return info;
      });
  }

  static emailLogin(emailLoginForm: EmailLoginForm) {
    // 等保需要对登录登接口进行加密
    return accountrequest
      .post(Config.aiInterviewUrl + "/account/login/emailPassword", {
        ...emailLoginForm,
        needAesEncrypt: true
      })
      .then((resp: any) => {
        const info = new Info().assign(resp.data.data);
        Auth.token = info.token;
        Auth.userId = info.userId;
        Store.getAccountStoreModule().then(module => {
          module.updateAccountInfo(info);
        });
        return info;
      });
  }
}
